import renderMenu from './renderMenu'
import toggleMenu from './toggleMenu'
import translateWidget from './translateWidget'

export function openMenu() {
  if (document.getElementById('asw-menu-dialog')) {
    toggleMenu()
  } else {
    renderMenu()
    toggleMenu()
  }

  translateWidget()
}
